export enum PetPersonalityType {
  'active' = 'active',
  'calm' = 'calm',
  'curious' = 'curious',
  'shy' = 'shy',
  'playful' = 'playful',
  'sleepy' = 'sleepy',
  'hungry' = 'hungry',
  'snappy' = 'snappy',
  'loyal' = 'loyal',
  'smart' = 'smart',
  'timid' = 'timid',
  'witty' = 'witty',
  'taciturn' = 'taciturn'
};


export const PetPersonalityTypeMap = {
  [PetPersonalityType.active]: '활동적',
  [PetPersonalityType.calm]: '차분함',
  [PetPersonalityType.curious]: '호기심 많음',
  [PetPersonalityType.shy]: '소극적',
  [PetPersonalityType.playful]: '장난꾸러기',
  [PetPersonalityType.sleepy]: '잠이 많음',
  [PetPersonalityType.hungry]: '많이 먹음',
  [PetPersonalityType.snappy]: '까칠함',
  [PetPersonalityType.loyal]: '충성스러움',
  [PetPersonalityType.smart]: '똑똑함',
  [PetPersonalityType.timid]: '무서움',
  [PetPersonalityType.witty]: '능글맞음',
  [PetPersonalityType.taciturn]: '과묵한',
};

export const PetPersonalityTypeScripts = {
  [PetPersonalityType.active]: [
    '나랑 같이 놀러 갈 사람?',
    '산책하러 나가고 싶어!',
    '오늘도 신나게 놀자!',
    '가만히 못 있겠어!',
    '뛰어다니는 게 세상에서 제일 좋아!',
    '나랑 공놀이 할 사람, 여기 모여라!',
    '새로운 장난감을 찾아 모험을 떠나자!',
    '몸이 근질근질해! 얼른 나가자!',
    '날씨가 너무 좋아! 밖에서 놀기 딱이야!',
    '자, 이제 놀 시간이야!'
  ],
  [PetPersonalityType.calm]: [
    '오늘도 평화로운 하루네.',
    '조용히 앉아 있는 시간이 좋아.',
    '햇살을 쬐며 낮잠을 자고 싶어.',
    '바람 소리가 참 듣기 좋구나.',
    '이렇게 가만히 있으면 마음이 편안해져.',
    '시끄럽게 굴지 않아도 괜찮아.',
    '따뜻한 자리에서 쉬고 싶어.',
    '서두르지 않아도 괜찮아.',
    '모두가 잠든 밤이 제일 좋아.',
    '잠깐 눈 좀 붙일게.'
  ],
  [PetPersonalityType.curious]: [
    '이게 뭐지? 냄새가 신기해!',
    '저기 구석에 뭐가 숨어 있을까?',
    '새로운 소리가 들려! 어디서 나는 거지?',
    '어디 한 번 올라가 볼까?',
    '세상은 온통 신기한 것투성이야!',
    '숨겨진 보물을 찾고 싶어.',
    '이 길 끝에는 뭐가 있을까?',
    '자꾸만 궁금한 게 생겨.',
    '저 문 뒤에는 뭐가 있을지 궁금해.',
    '모든 걸 다 알고 싶어!'
  ],
  [PetPersonalityType.shy]: [
    '저기, 나한테 말 걸지 마...',
    '모르는 사람이 많아서 조금 무서워.',
    '숨어 있을 곳을 찾아봐야겠어.',
    '괜히 부끄럽네...',
    '먼저 다가가는 건 역시 어려워.',
    '조용히 혼자 있는 게 좋아.',
    '날 빤히 쳐다보지 말아줘.',
    '조심스럽게 다가가 볼까?',
    '가까이 오지 마, 부끄럽단 말이야!',
    '작은 목소리로 말해줘.'
  ],
  [PetPersonalityType.playful]: [
    '나랑 놀자! 놀아줘!',
    '방금 네 장난감 숨겨놨지롱!',
    '까꿍! 내가 여기 있지!',
    '헤헤, 내가 제일 좋아하는 장난은 이거야!',
    '어디로 숨었는지 알아맞혀 봐!',
    '장난치다 들켜도 괜찮아!',
    '내 엉뚱한 행동에 놀랐어?',
    '누가누가 더 재밌게 노나 내기할까?',
    '나 잡을 수 있으면 잡아 봐!',
    '간지럼 태우는 게 제일 재밌어!'
  ],
  [PetPersonalityType.sleepy]: [
    'zzz...',
    '오늘은 푹 자고 싶어.',
    '아침부터 잠이 쏟아지네.',
    '지금부터 낮잠 시간이야.',
    '잠자리가 제일 편해.',
    '하품이 멈추지 않아...',
    '따뜻한 이불 속에서 나가고 싶지 않아.',
    '꿈속에서 산책하고 올게.',
    '잠깐만, 5분만 더 자고 일어날게.',
    '졸려... Zzz...'
  ],
  [PetPersonalityType.snappy]: [
    '말 걸지 마, 귀찮아.',
    '가까이 오지 마.',
    '내버려 둬!',
    '내 심기 건드리지 마.',
    '이리 와, 말 안 듣게.',
    '흥, 뭐 어쩌라고.',
    '투덜투덜...',
    '건드리면 물어버릴 거야!',
    '네가 뭔데 나한테 이래라저래라야?',
    '저리 가.'
  ],
  [PetPersonalityType.loyal]: [
    '난 오직 너만을 따를 거야.',
    '너의 곁을 지키는 것이 내 기쁨이야.',
    '너만 있으면 돼.',
    '내가 널 보호해 줄게.',
    '언제나 네 편이야.',
    '어딜 가든 항상 네 옆에 있을게.',
    '넌 나에게 전부야.',
    '나에게 명령해줘.',
    '걱정 마, 내가 있으니까.',
    '난 절대 널 배신하지 않아.'
  ],
  [PetPersonalityType.smart]: [
    '그건 그렇게 하는 게 아니야.',
    '내가 먼저 계산했어야 했는데.',
    '이 상황의 핵심은 그거지!',
    '내가 뭘 원하는지 알아?',
    '내가 이럴 줄 알았어!',
    '이건 그냥 단순한 문제가 아냐.',
    '그렇게 하면 효율이 떨어진다고.',
    '내가 설명해 줄게.',
    '나의 지혜가 필요할 거야.',
    '생각은 내가 할게, 넌 그냥 따라와.'
  ],
  [PetPersonalityType.timid]: [
    '나 여기 있어도 될까?',
    '혹시 나한테 화났어?',
    '무서워... 누가 도와줬으면 좋겠어.',
    '나 때문에 모두가 불편해하는 건 아닐까?',
    '너무 놀라게 하지 마세요...',
    '내가 잘못한 건가...?',
    '아무도 나를 찾아내지 못했으면 좋겠어.',
    '조용히 있었으면 좋겠어.',
    '나... 그냥 여기 있을래.',
    '나를... 나를 봐줘...'
  ],
  [PetPersonalityType.witty]: [
    '이거 실화냐?',
    '지금 농담하는 거야?',
    '너 지금 장난치는 거지?',
    '나만 아는 비밀이 있어!',
    '내 이야기 들어봐, 웃다가 배꼽 빠질 걸?',
    '말해줄 수 없는 비밀이 있어!',
    '재밌는 이야기 해줄까?',
    '나는 언제나 특별한 일을 해!',
    '나랑 놀면 지루하지 않아!',
    '나는 누구도 따라올 수 없는 특별한 매력이 있지!'
  ],
  [PetPersonalityType.taciturn]: [
    '....',
    '글쎄.',
    '몰라.',
    '아니.',
    '응.',
    '알았어.',
    '그래.',
    '흠.',
    '....(조용히 생각에 잠김)',
    '....(빤히 쳐다만 본다)'
  ]
};